/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Indicates the type of amortization which is required for a phase.
 */
export enum AmortizationKind {
    /**
     * Invalid value.
     */
    None = "None",
    /**
     * The loan is treated as a structured loan with a fixed payment each payment period.
     */
    Structured = "Structured",
    /**
     * The loan is treated as an unstructured loan with a minimum payment that varies with
     * the principal.
     */
    Unstructured = "Unstructured",
    /**
     * A phase during which only interest is paid on the loan.
     */
    InterestOnly = "InterestOnly",
}
